import React, { useState, useContext, useEffect, useRef } from "react";
import { CircularProgress } from "@mui/material";
import withStyles from "@mui/styles/withStyles";
import { FormStyle } from "../../styles/pages/ContentStudio/WithStylesObjs";
import "../../styles/pages/ContentStudio/DynDialogue.scss";
import { useTranslation } from "react-i18next";
import SearchSortBannerTemplate from "../../components/Manager/SearchSortBannerTemplate";
import CardContainer from "../../components/Manager/CardsContainer.js";
import ErrComponentToRender from "../../Uitls/apiErrorHandling";
import {
  searchBanners,
  getNewBrandsAndcampaigns,
  getMarketList,
  getDocIdfromveeva,
  getOnetimeAsset,
  searchBannersCountBasedOnCreatedBy,
} from "../../services/apis";
import { getOrDash } from "../../Uitls/DetailsHelpers";
import { toast } from "react-toastify";
import ValueContext from "../../ContextAPi/appContext";
//import ErrComponentToRender from "../../Uitls/apiErrorHandling";
import GoToTeplatesContainer from "../../components/BannerManager/GoToTeplatesContainer";
import "./TemplateM.scss";
import "../../styles/pages/Banners/BannerManager.scss";
import GotoRecentlyViewed from "../../components/BannerManager/gotoRecentlyViewed";
import MultipleRvcvModal from "../../components/BannerManager/MultipleRvcvModal";
import NobannerFoundBg from "../../images/noBannerFoundBg.svg";
import NotemplateFoundBg from "../../images/noTemplateFound.svg";
import NobannerFound from "../../images/NobannerFound.svg";
import InfiniteScroll from "react-infinite-scroll-component";
import NotemplateFound from "../../images/Notemplated.svg";

function TemplateForms(props) {
  const { initialFvalues, values, setValues } = props;
  const appData = useContext(ValueContext);
  const { t } = useTranslation();
  const {
    preDefined,
    setPredefined,
    customTemp,
    setCustomBannerSize,
    setActiveButton,
    activeButton,
    deleteFilterOption,
    setIsSearchBarEmpty,
    isSearchBarEmpty,
    clickOncrossIcon,
    setBannerDetails,
    bannerDetails,
  } = props;

  const [selectedFilters, setSelectedFilters] = useState({
    Product: [],
    Country: [],
    "Banner Type": [],
    "Content Type": [],
    "MLR Status": [],
    Indication: [],
  });

  const [brandsAndCampaigns, setBrandsAndCampaigns] = useState([]);
  const [marketDataSource, setMarketDataSource] = useState([]);
  const [selectedMarket, setSelectedMarket] = useState(undefined);
  const [templateTypes, setTemplateTypes] = useState(["Static", "Animated"]);
  const [searchText, setSearchText] = useState("");
  const [genericInfo, setGenericInfo] = useState({
    brand: [],
    campaign: "",
    market: "",
    isAnimated: "",
  });

  const [dropdownInfo, setDropdownInfo] = useState({
    brand: [],
    campaign: "",
    market: "",
    isAnimated: "",
  });
  const [createdByMeCount, setCreatedByMeCount] = useState(0);
  const [createdByOthersCount, setCreatedByOthersCount] = useState(0);
  const [totalBannersCount, setTotalBannersCount] = useState(0);
  const [loading, setLoading] = useState(false);
  const [loadingData, setLoadingData] = useState(false);
  const [resultHeader, setResultHeader] = useState({
    cardsCount: 0,
    searched: false,
    resultTitle: `Recently Viewed (0)`,
  });
  const scrollableDivRef = useRef(null);
  const latestSearchRequestIdRef = useRef(0);
  const [responseData, setResponseData] = useState([]);
  const [allCardsData, setAllCardsData] = useState([]);
  const [search, setSearch] = useState("recent");
  const [createdByMe, setCreatedByMe] = useState({ status: "me", data: [] });
  const [hide3dotIcon, setHide3dotIcon] = useState(true);
  const [bannerCount, setBannerCount] = useState(0);
  const [generateRVCV, setGenerateRVCV] = useState(false);
  const [disableProceedbut, setDisableProceedbut] = useState(false);
  const [openRVCvmodal, setOpenRVCvmodal] = useState(false);
  const [arrcheckboxSelection, setArrcheckboxSelection] = useState([]);
  const [selectMultipleBanner, setSelectMultipleBanner] = useState([]);
  const [hasMore, sethasMore] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [canFetchMore, setCanFetchMore] = useState(true);
  const [isOnetimeAsset, setIsonetimeAsset] = useState(false);
  const [oneTimeAssets, setOnetimeAssets] = useState([]);

  useEffect(() => {
    const newSelectedFilters = {
      Product: Array.isArray(values?.brand) ? values.brand : [],
      Country: Array.isArray(values?.market) ? values.market : [],
      "Banner Type": Array.isArray(values?.templateType)
        ? values.templateType
        : [],
      "Content Type": Array.isArray(values?.contentType)
        ? values.contentType
        : [],
      "MLR Status": Array.isArray(values?.mlrStatus) ? values.mlrStatus : [],
      Indication: Array.isArray(values?.indication) ? values.indication : [],
    };

    setSelectedFilters(newSelectedFilters);
  }, [
    values?.brand,
    values?.market,
    values?.templateType,
    values?.contentType,
    values?.mlrStatus,
    values?.indication,
  ]);

  useEffect(() => {
    const hasFilters =
      (values?.brand && values.brand.length > 0) ||
      (values?.market && values.market.length > 0) ||
      (values?.templateType && values.templateType.length > 0) ||
      (values?.contentType && values.contentType.length > 0) ||
      (values?.mlrStatus && values.mlrStatus.length > 0) ||
      (values?.indication && values.indication.length > 0) ||
      (values?.templateNameInput && values.templateNameInput.trim());

    if (hasFilters) {
      getSearchedTemplates(1);
    }
  }, [values]);

  const scrollToTop = () => {
    const scrollableDiv = document.getElementById("scrollableDiv");
    if (scrollableDiv) {
      scrollableDiv.scrollTop = 0;
    }
  };

  const removeSearchresultCard = () => {
    setLoading(true);
    setLoadingData(true);
    fetchAllTemplates("delete", createdByMe.status);
  };

  useEffect(() => {
    setGenericInfo({ ...genericInfo, campaign: "" });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [genericInfo.brand]);

  const fetchAllTemplates = () => {
    if (clickOncrossIcon) {
      setLoading(false);
    } else {
      setLoading(true);
    }
    setLoadingData(true);
    setCreatedByMe({ status: "me", data: [] });
    setResponseData([]);
    setAllCardsData([]);
    let madeBy =
      activeButton === 1 ? "me" : activeButton === 2 ? "other" : "all";
    getAllBanners("BANNER", madeBy);
  };

  useEffect(() => {
    handleReset("useEffect");
    setLoading(true);
    setLoadingData(true);
    appData.setFlagEditFlow(false);
    appData.setFlagEditBanner(false);
    fetchBrandsAndCampaigns();
    fetchMarketData();
    setCreatedByMe({ status: "me", data: [] });
    setResponseData([]);
    setAllCardsData([]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.banner]);

  // const getAllBanners = (type = "BANNER", madeBy = "me") => {
  //   searchBanners(
  //     "BANNER",
  //     dropdownInfo,
  //     {},
  //     "",
  //     1,
  //     madeBy,
  //     async (response, err, errorCode) => {
  //       let data =
  //         (await response?.data?.data?.sort(
  //           (a, b) => b?.updatedDateTime - a?.updatedDateTime,
  //         )) || [];

  //       if (err) {
  //         setLoading(false);
  //         setLoadingData(false);
  //         const errCoponent = ErrComponentToRender(errorCode);
  //         categoriesErr(errCoponent);
  //       } else {
  //         const totalRecords = response?.data?.totalRecords || 0;
  //         const totalBanners = response?.data?.totalBanners || 0;
  //         localStorage.setItem("totalBanners", totalBanners);
  //         localStorage.setItem("totalItemsForSearch", totalRecords);
  //         setTotalBannersCount(totalBanners);
  //         if (madeBy === "me") {
  //           setCreatedByMeCount(totalRecords);
  //           setCreatedByOthersCount(totalBanners - totalRecords);
  //         } else if (madeBy === "other") {
  //           setCreatedByOthersCount(totalRecords);
  //           setCreatedByMeCount(totalBanners - totalRecords);
  //         } else if (madeBy === "all") {
  //           // for "all" we only know totalBanners; Me/Others already set
  //         }

  //         let more =
  //           response?.data?.totalPages - response?.data?.pageNumber > 0;
  //         sethasMore(more);
  //         setLoading(false);
  //         setLoadingData(false);
  //         setCreatedByMe({
  //           ...createdByMe,
  //           status: "me",
  //           data: data.filter((template) => template?.madeBy === "me"),
  //         });
  //         setResponseData(data.filter((template) => template?.madeBy !== "me"));

  //         setAllCardsData(data);
  //         setSearch("search");
  //       }
  //     },
  //   );
  // };
  const getAllBanners = (type = "BANNER", madeBy = "me") => {
    setLoading(true);

    searchBanners(
      "BANNER",
      dropdownInfo,
      {},
      "",
      1,
      madeBy,
      (response, err, errorCode) => {
        if (err) {
          setLoading(false);
          setLoadingData(false);
          categoriesErr(ErrComponentToRender(errorCode));
          return;
        }

        const rawData = response?.data?.data || [];

        const data = rawData.sort(
          (a, b) => b?.updatedDateTime - a?.updatedDateTime,
        );

        const totalRecords = response?.data?.totalRecords || 0;
        const totalBanners = response?.data?.totalBanners || 0;

        const more =
          response?.data?.totalPages - response?.data?.pageNumber > 0;

        const meData = data.filter((t) => t?.madeBy === "me");
        const otherData = data.filter((t) => t?.madeBy !== "me");

        setTotalBannersCount(totalBanners);
        sethasMore(more);
        setCreatedByMe({ status: "me", data: meData });
        setResponseData(otherData);
        setAllCardsData(data);
        setSearch("search");

        setLoading(false);
        setLoadingData(false);
      },
    );
  };
  const getOnetimeAssetContent = () => {
    getOnetimeAsset(async (response, err) => {
      if (err) {
        // toast.error(
        //   <div className="notificationText">
        //     {t("Failed to get the Doc Id")}
        //   </div>,
        // );
        console.log(err);
      } else {
        const data = (await response.data.data) || [];
        setOnetimeAssets(data);
      }
    });
  };

  useEffect(() => {
    getOnetimeAssetContent();
  }, []);
  const oneTimeDocNumbers = new Set(
    oneTimeAssets?.map((item) => item.veevaDocNumber),
  );

  const handleChangeField = (event) => {
    const { name, value } = event.target;
    setValues({
      ...values,
      [name]: value,
      canReset: true,
    });
  };

  const handleReset = () => {
    setHide3dotIcon(true);
    setValues({
      ...initialFvalues,
      contentType: [],
      mlrStatus: [],
      indication: [],
    });

    const resetFilters = {
      Product: [],
      Country: [],
      "Banner Type": [],
      "Content Type": [],
      "MLR Status": [],
      Indication: [],
    };
    setSelectedFilters(resetFilters);
    setGenericInfo({
      brand: [],
      campaign: "",
      market: "",
    });
    setSearchText("");
    setSelectedMarket("");
    setDropdownInfo({ brand: [], campaign: "", market: "", isAnimated: "" });
    setResponseData([]);
    setSearch("recent");
    setResultHeader({
      cardsCount: bannerCount,
      searched: false,
      resultTitle: `Recently Viewed (${bannerCount})`,
    });
    setGenerateRVCV(false);
    setIsSearchBarEmpty(true);
  };

  const deleteFilterOptionSync = (item) => {
    let updatedValues = { ...values };
    let updatedSelectedFilters = { ...selectedFilters };
    let updatedGenericInfo = { ...genericInfo };
    let updatedDropdownInfo = { ...dropdownInfo };

    if (item.metaDataType === "product") {
      updatedValues.brand =
        values.brand?.filter((brand) => brand.id !== item.id) || [];
      updatedSelectedFilters.Product =
        updatedSelectedFilters.Product?.filter(
          (brand) => brand.id !== item.id,
        ) || [];
      updatedGenericInfo.brand = updatedValues.brand;
      updatedDropdownInfo.brand = updatedValues.brand;
    } else if (item.metaDataType === "market") {
      updatedValues.market =
        values.market?.filter((market) => market.id !== item.id) || [];
      updatedSelectedFilters.Country =
        updatedSelectedFilters.Country?.filter(
          (market) => market.id !== item.id,
        ) || [];
      updatedGenericInfo.market = updatedValues.market;
      updatedDropdownInfo.market = updatedValues.market;
    } else if (item.metaDataType === "indication") {
      updatedValues.indication =
        values.indication?.filter((indication) => indication.id !== item.id) ||
        [];
      updatedSelectedFilters.Indication =
        updatedSelectedFilters.Indication?.filter(
          (indication) => indication.id !== item.id,
        ) || [];
    } else if (item.metaDataType === "mlrStatus") {
      updatedValues.mlrStatus =
        values.mlrStatus?.filter((status) => status.id !== item.id) || [];
      updatedSelectedFilters["MLR Status"] =
        updatedSelectedFilters["MLR Status"]?.filter(
          (status) => status.id !== item.id,
        ) || [];
    } else if (item.metaDataType === "contentType") {
      updatedValues.contentType =
        values.contentType?.filter(
          (contentType) => contentType.id !== item.id,
        ) || [];
      updatedSelectedFilters["Content Type"] =
        updatedSelectedFilters["Content Type"]?.filter(
          (contentType) => contentType !== item.displayName,
        ) || [];
    } else if (
      item.displayName === "Static" ||
      item.displayName === "Animated"
    ) {
      updatedValues.templateType = [];
      updatedSelectedFilters["Banner Type"] = [];
      updatedGenericInfo.templateType = [];
      updatedDropdownInfo.isAnimated = "";
    } else if (
      item.displayName === "One-time content" ||
      item.displayName === "Modular Content"
    ) {
      updatedValues.contentType = [];
      updatedSelectedFilters["Content Type"] = [];
    } else if (item.metaDataType === "templateNameInput") {
      updatedValues.templateNameInput = "";
      setSearchText("");
    }

    setValues(updatedValues);
    setSelectedFilters(updatedSelectedFilters);
    setGenericInfo(updatedGenericInfo);
    setDropdownInfo(updatedDropdownInfo);

    if (deleteFilterOption) {
      deleteFilterOption(item);
    }
  };

  const fetchBrandsAndCampaigns = () => {
    getNewBrandsAndcampaigns((response, err, errCode) => {
      if (err) {
        const errCoponent = ErrComponentToRender(errCode);
        toast.error(errCoponent);
      } else {
        const data = response.data;
        if (data && data.length > 0) {
          let sortedData;
          sortedData = data.slice().sort((a, b) => {
            const brandNameA = a.brandName.trim().toUpperCase();
            const brandNameB = b.brandName.trim().toUpperCase();
            return brandNameA.localeCompare(brandNameB, "en", {
              sensitivity: "base",
            });
          });
          sortedData = [...sortedData].map((data) => {
            let object = data;
            object["displayName"] = `${object.brandName}`;
            return object;
          });
          setBrandsAndCampaigns(data);
        }
      }
    });
  };

  const getBrandsToPopulate = (origin) => {
    if (!brandsAndCampaigns || brandsAndCampaigns.length <= 0) {
      return [];
    }
    let brandNameArray = [];
    [...brandsAndCampaigns].forEach((object) => {
      if (origin === "basedOnNew") {
        if (object.brandName !== "— Not Brand Specific —")
          brandNameArray = [...brandNameArray, object.brandName];
      } else brandNameArray = [...brandNameArray, object.brandName];
    });
    return brandNameArray;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === "templateType") {
      setValues({
        ...values,
        [name]: [
          {
            ["displayName"]: value,
          },
        ],
      });
    } else {
      setValues({
        ...values,
        [name]: value,
        canReset: true,
      });
    }
    setGenericInfo({ ...genericInfo, [name]: value });
    if (name === "templateType") {
      setDropdownInfo({
        ...dropdownInfo,
        isAnimated: value === "Animated" ? true : false,
      });
    }

    if (brandsAndCampaigns) {
      brandsAndCampaigns.forEach((brand) => {
        if (brand.brandName === value) {
          setDropdownInfo({ ...dropdownInfo, brand: brand.brandDamId });
        }
        brand.campaigns.forEach((campaign) => {
          if (campaign.campaignName === value)
            setDropdownInfo({
              ...dropdownInfo,
              campaign: campaign.campaignId,
            });
        });
      });
    }
  };

  const fetchMarketData = () => {
    getMarketList((response, err, errCode) => {
      if (err) {
        const errCoponent = ErrComponentToRender(errCode);
        toast.error(errCoponent);
      } else {
        const data = response.data;
        if (data) {
          let marketData = data;
          if (marketData && marketData.length > 0) {
            marketData = [...marketData].map((market) => {
              let object = {
                code: market.countryDamId,
                shortName: market.ShortName,
                name: market.marketName,
              };
              object["displayName"] = `${object.name}`;
              return object;
            });
            if (marketData && marketData.length > 0) {
              marketData = [...marketData].sort((marketOne, marketTwo) => {
                if (marketOne.name < marketTwo.name) {
                  return -1;
                }
                if (marketOne.name > marketTwo.name) {
                  return 1;
                }
                return 0;
              });
              setMarketDataSource(marketData);
            }
          }
        }
      }
    });
  };

  const handleMarketChange = (market) => {
    if (market) {
      setSelectedMarket(market);
      setDropdownInfo({ ...dropdownInfo, market: market.countryDamId });
    }
  };

  const categoriesErr = (value) => {
    toast.error(value, { position: toast.POSITION.TOP_RIGHT });
  };

  const [nobannerFound, setnobannerFound] = useState(false);
  const prevActiveButton = useRef();
  const prevCurrentPage = useRef();

  useEffect(() => {
    getSearchedTemplates();
    currentPage === 1 && scrollToTop();
    prevActiveButton.current = activeButton;
    prevCurrentPage.current = currentPage;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activeButton, currentPage]);

  const getSearchedTemplates = (page) => {
    if (clickOncrossIcon) {
      setLoading(false);
    } else {
      setLoading(true);
    }
    setLoadingData(true);

    if (
      values.brand ||
      values.campaign ||
      values.market ||
      values.templateType ||
      values.contentType ||
      values.indication ||
      values.mlrStatus ||
      (values.templateNameInput && values.templateNameInput.trim())
    ) {
      setResponseData([]);
      setResultHeader({
        cardsCount: 0,
        searched: true,
        resultTitle: `Search Results...`,
      });
      let madeBy =
        activeButton === 1 ? "me" : activeButton === 2 ? "other" : "all";
      let pageNo = page ? page : currentPage;

      const updatedDropdownInfo = {
        ...dropdownInfo,
        mlrStatus:
          values.mlrStatus && Array.isArray(values.mlrStatus)
            ? values.mlrStatus.map(
                (status) =>
                  status.id || status.statusName || status.displayName,
              )
            : [],
        indication:
          values.indication && Array.isArray(values.indication)
            ? values.indication.map(
                (indication) =>
                  indication.id || indication.indicationName || indication.name,
              )
            : [],
      };

      //  Fetch counts for all categories when filters change or on page 1
      if (pageNo === 1) {
        const fetchCountsPromises = ["me", "other", "all"].map((category) => {
          return new Promise((resolve) => {
            searchBanners(
              props.banner ? "BANNER" : "TEMPLATE",
              updatedDropdownInfo,
              values,
              encodeURIComponent(values.templateNameInput || ""),
              1,
              category,
              async (response, err) => {
                if (!err) {
                  const totalRecords = response?.data?.totalRecords || 0;
                  const totalBanners = response?.data?.totalBanners || 0;
                  resolve({
                    category,
                    totalRecords,
                    totalBanners,
                  });
                } else {
                  resolve({ category, totalRecords: 0, totalBanners: 0 });
                }
              },
            );
          });
        });

        Promise.all(fetchCountsPromises).then((results) => {
          const meResult = results.find((r) => r.category === "me");
          const otherResult = results.find((r) => r.category === "other");
          const allResult = results.find((r) => r.category === "all");
          const meCount = meResult?.totalRecords || 0;
          const otherCount = otherResult?.totalRecords || 0;
          // Use the totalRecords from "all" query, or sum of me + others as fallback
          const allCount = allResult?.totalRecords || meCount + otherCount;

          setCreatedByMeCount(meCount);
          setCreatedByOthersCount(otherCount);
          setTotalBannersCount(allCount);
        });
      }

      // Then fetch the actual data for the current tab
      const requestId = ++latestSearchRequestIdRef.current;
      searchBanners(
        props.banner ? "BANNER" : "TEMPLATE",
        updatedDropdownInfo,
        values,
        encodeURIComponent(values.templateNameInput || ""),
        pageNo,
        madeBy,
        async (response, err, errorCode) => {
          if (requestId !== latestSearchRequestIdRef.current) {
            return;
          }
          let data =
            (await response?.data?.data?.sort(
              (a, b) => b?.updatedDateTime - a?.updatedDateTime,
            )) || [];
          data = pageNo === 1 ? data : [...allCardsData, ...data];
          if (err) {
            setLoading(false);
            setLoadingData(false);
            const errCoponent = ErrComponentToRender(errorCode);
            categoriesErr(errCoponent);
            setCanFetchMore(true);
          } else {
            if (madeBy !== "all") {
              localStorage.setItem(
                "totalItemsForSearch",
                response?.data?.totalRecords,
              );
              localStorage.setItem(
                "totalBanners",
                response?.data?.totalBanners,
              );
            }

            let more =
              response?.data?.totalPages - response?.data?.pageNumber > 0;
            setCanFetchMore(true);
            sethasMore(more);
            setLoading(false);
            setLoadingData(false);
            setCreatedByMe({
              ...createdByMe,
              status: "me",
              data: data.filter((template) => template?.madeBy === "me"),
            });
            setResponseData(
              data.filter((template) => template?.madeBy !== "me"),
            );

            setAllCardsData(data);
            setSearch("search");
          }
        },
      );
    } else {
      const errCoponent = ErrComponentToRender(602);
      categoriesErr(errCoponent);
      setLoading(false);
      setLoadingData(false);
    }
  };
  const showSelected = (me) => {
    setCreatedByMe({ ...createdByMe, status: me === "me" ? "me" : false });
  };

  const lockUnlockBannerAtFE = (assetId, lockStatus) => {
    let tempCreatedByMe = JSON.parse(JSON.stringify(createdByMe));
    if (tempCreatedByMe && Array.isArray(tempCreatedByMe.data)) {
      for (const elem of tempCreatedByMe.data) {
        if (elem.damDocNumber === assetId) {
          elem.lockStatus = lockStatus;
        }
      }
    }

    setAllCardsData(tempCreatedByMe?.data || []);
    setCreatedByMe(tempCreatedByMe);
  };

  const getFilterDataToDisplay = () => {
    let result = [];

    if (values["brand"]?.length > 0) {
      result = result.concat(...values["brand"]);
    }

    if (values["market"]?.length > 0) {
      result = result.concat(
        values["market"].filter(
          (marketItem) =>
            !result.some((resultItem) => resultItem.id === marketItem.id),
        ),
      );
    }

    if (values["templateType"]) {
      result = result.concat(...values["templateType"]);
    }

    if (values["contentType"]?.length > 0) {
      result = result.concat(
        values["contentType"].filter(
          (contentTypeItem) =>
            !result.some((resultItem) => resultItem.id === contentTypeItem.id),
        ),
      );
    }

    if (values["mlrStatus"]?.length > 0) {
      result = result.concat(
        values["mlrStatus"].filter(
          (statusItem) =>
            !result.some((resultItem) => resultItem.id === statusItem.id),
        ),
      );
    }
    if (values["indication"]?.length > 0) {
      result = result.concat(
        values["indication"].filter(
          (indicationItem) =>
            !result.some((resultItem) => resultItem.id === indicationItem.id),
        ),
      );
    }

    if (values?.templateNameInput) {
      result = result.concat(
        ...[
          {
            id: 1,
            displayName: values?.templateNameInput,
            veevaId: 1,
            metaDataType: "templateNameInput",
          },
        ],
      );
    }

    return result.filter(
      (item, index, self) => index === self.findIndex((t) => t.id === item.id),
    );
  };

  const [isFilters, setIsFilters] = useState(false);

  const handlePageChange = (page) => {
    setCanFetchMore(false);
    if (prevActiveButton.current - activeButton === 0) {
      setCurrentPage(() => page);
    }
  };

  useEffect(() => {
    if (
      (values?.brand && values.brand.length > 0) ||
      (values?.market && values.market.length > 0) ||
      (values?.templateNameInput && values.templateNameInput.length > 0) ||
      (values?.templateType && values.templateType.length > 0) ||
      (values?.contentType && values.contentType.length > 0) ||
      (values?.mlrStatus && values.mlrStatus.length > 0) ||
      (values?.indication && values.indication.length > 0)
    ) {
      setnobannerFound(true);
    } else {
      setnobannerFound(false);
    }

    if (
      (!values?.brand || values.brand.length === 0) &&
      (!values?.market || values.market.length === 0) &&
      (!values?.templateNameInput || values.templateNameInput.length === 0) &&
      (!values?.templateType || values.templateType.length === 0) &&
      (!values?.contentType || values.contentType.length === 0) &&
      (!values?.mlrStatus || values.mlrStatus.length === 0) &&
      (!values?.indication || values.indication.length === 0)
    ) {
      setIsFilters(false);
    } else {
      setIsFilters(true);
    }
  }, [values]);

  return (
    <div className="templateOuterContainer">
      <>
        {loading ||
          (loadingData && (
            <>
              <div className="modal-backdrop fade show"> </div>
              <CircularProgress size="30px" className="customLoader" />{" "}
            </>
          ))}

        <SearchSortBannerTemplate
          initialFvalues={initialFvalues}
          handleReset={handleReset}
          handleFilter={props.handleFilter}
          banner={props.banner}
          openNewBannerModal={props.openNewBannerModal}
          handleCreateTempModal={props.handleCreateTempModal}
          createdByMe={createdByMe}
          createdByOthers={responseData}
          showSelected={showSelected}
          selectedFilterData={values["brand"]}
          marketDataSource={marketDataSource}
          getSearchedTemplates={getSearchedTemplates}
          handleChangeField={handleChangeField}
          values={values}
          setValues={setValues}
          activeButton={activeButton}
          setActiveButton={setActiveButton}
          setCurrentPage={setCurrentPage}
          currentPage={currentPage}
          setAllCardsData={setAllCardsData}
          allCardsData={allCardsData}
          setCanFetchMore={setCanFetchMore}
          handleChange={handleChange}
          genericInfo={genericInfo}
          templateTypes={templateTypes}
          deleteFilterOption={deleteFilterOptionSync}
          getFilterDataToDisplay={getFilterDataToDisplay}
          handleMarketChange={handleMarketChange}
          fetchAllTemplates={fetchAllTemplates}
          setSearchText={setSearchText}
          searchText={searchText}
          setIsSearchBarEmpty={setIsSearchBarEmpty}
          isSearchBarEmpty={isSearchBarEmpty}
          selectedFilters={selectedFilters}
          setSelectedFilters={setSelectedFilters}
          createdByMeCount={createdByMeCount}
          createdByOthersCount={createdByOthersCount}
          totalBannersCount={totalBannersCount}
        />

        <CardContainer
          values={values}
          setValues={setValues}
          getSearchedTemplates={getSearchedTemplates}
          banner={props.banner}
          setIsOpen={props.setIsOpen}
          isOpen={props.isOpen}
          filtersData={props.filtersData}
          deleteFilterOption={deleteFilterOptionSync}
          resetAll={props.resetAll}
          handleReset={handleReset}
          setnobannerFound={setnobannerFound}
          fetchAllTemplates={fetchAllTemplates}
          getFilterDataToDisplay={getFilterDataToDisplay}
          setSearchText={setSearchText}
          searchText={searchText}
          noData={
            activeButton === 1
              ? createdByMe?.data
              : activeButton === 2
                ? responseData
                : allCardsData
          }
          setGenericInfo={setGenericInfo}
          genericInfo={genericInfo}
          setIsSearchBarEmpty={setIsSearchBarEmpty}
          isSearchBarEmpty={isSearchBarEmpty}
          selectedFilters={selectedFilters}
          setSelectedFilters={setSelectedFilters}
          handleResetSync={handleReset}
        />

        <div style={{ padding: "0 10px" }}>
          <InfiniteScroll
            dataLength={allCardsData?.length}
            next={() => {
              if (canFetchMore) {
                handlePageChange(currentPage + 1);
              }
            }}
            hasMore={hasMore}
            scrollableTarget="scrollableDiv"
            scrollThreshold={0.9}
          >
            <div
              id="scrollableDiv"
              className={`TemplateContainerM custonScrollBar ${
                isFilters ? "filtersApplied" : ""
              }`}
            >
              <div className="recentlyViewDivM ">
                <div className="row recentlyCardsRowM" ref={scrollableDivRef}>
                  {allCardsData?.length === 0 ? (
                    <div className="searchEmptyRowBlk">
                      <div style={{ position: "relative" }}>
                        {!loadingData && nobannerFound ? (
                          <img
                            src={props.banner ? NobannerFound : NotemplateFound}
                            alt="thumbnail"
                            className="emptyBannerImage img-fluid"
                          />
                        ) : null}
                        {!loadingData &&
                          !nobannerFound &&
                          allCardsData?.length === 0 && (
                            <img
                              src={
                                props.banner
                                  ? NobannerFoundBg
                                  : NotemplateFoundBg
                              }
                              alt="thumbnail"
                              className="emptyBannerImage img-fluid"
                            />
                          )}
                      </div>
                    </div>
                  ) : !props.banner ? (
                    <GoToTeplatesContainer
                      setBannerDetails={setBannerDetails}
                      bannerDetails={bannerDetails}
                      preDefined={preDefined}
                      setPredefined={setPredefined}
                      customTemp={customTemp}
                      setCustomBannerSize={setCustomBannerSize}
                      responseData={allCardsData}
                      search={search}
                      setLoading={setLoading}
                      setResponseData={{
                        createdByMe: createdByMe,
                        setData: createdByMe.status
                          ? setCreatedByMe
                          : setResponseData,
                      }}
                      hide3dotIcon={hide3dotIcon}
                      getBrandsToPopulate={getBrandsToPopulate}
                    />
                  ) : (
                    <GotoRecentlyViewed
                      oneTimeDocNumbers={oneTimeDocNumbers}
                      setBannerDetails={setBannerDetails}
                      bannerDetails={bannerDetails}
                      fetchAllTemplates={fetchAllTemplates}
                      responseData={allCardsData}
                      createdByMe={createdByMe?.status}
                      search={search}
                      removeSearchresultCard={removeSearchresultCard}
                      setLoading={setLoading}
                      generateRVCV={generateRVCV}
                      disableProceedbut={disableProceedbut}
                      setDisableProceedbut={setDisableProceedbut}
                      selectMultipleBanner={selectMultipleBanner}
                      setSelectMultipleBanner={setSelectMultipleBanner}
                      arrcheckboxSelection={arrcheckboxSelection}
                      setArrcheckboxSelection={setArrcheckboxSelection}
                      hide3dotIcon={hide3dotIcon}
                      lockUnlockBannerAtFE={lockUnlockBannerAtFE}
                      setCurrentPage={setCurrentPage}
                      getSearchedTemplates={getSearchedTemplates}
                    />
                  )}
                </div>
              </div>
            </div>
          </InfiniteScroll>
        </div>

        {loading && (
          <>
            <div className="modal-backdrop fade show"> </div>
            <CircularProgress size="30px" className="customLoader" />{" "}
          </>
        )}
        {openRVCvmodal && (
          <MultipleRvcvModal
            openRVCvmodal={openRVCvmodal}
            setOpenRVCvmodal={setOpenRVCvmodal}
            selectMultipleBanner={selectMultipleBanner}
          />
        )}
      </>
    </div>
  );
}

export default withStyles(FormStyle)(TemplateForms);
